import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function RedirectingScreen() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const googleAuth = searchParams.get("token");
    const reg = searchParams.get("reg");
    const err = searchParams.get("err");

    if (err !== null) {
      localStorage.setItem("err", err);
      navigate("/", { replace: true });
      return;
    }
    if (googleAuth === null) {
      navigate("/", { replace: true });
    } else {
      localStorage.setItem("jwt", googleAuth);
      localStorage.setItem("reg", reg);
      navigate("/game", { replace: true });
    }
  }, [navigate, searchParams]);

  return <div>Redirecting you to ACM's Recruitment Game!</div>;
}
